export default __webpack_public_path__ + "static/media/MAP-Regional-Bahai-Council-Boundaries.454c82a2.jpeg";